window.addEventListener('DOMContentLoaded', () => {
  if (window.Extend && window.Extend.buttons) {
    try {
      // Get params from URL
      const params = (new URL(document.location)).searchParams;

      // Check if leadToken or leadtoken is in the URL
      const leadToken = params.get('leadToken')
        ? params.get('leadToken')
        : params.get('leadtoken');

      if (leadToken) {
        Extend.aftermarketModal.open({
          leadToken,
          onClose(plan, product, quantity) {
            if (plan && product && product.id && product.name) {
              // a user has selected a plan.  Add it to their cart.
              const { planId, price, term } = plan;
              const extendSKU = planId === 'A2-SGFIT-4y' ? '50385440145690' : '50385306616090';

              // add to cart using fetch
              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  Accept: 'application/json',
                },
                body: JSON.stringify({
                  id: extendSKU,
                  quantity: 1,
                  properties: {
                    __leadToken: leadToken,
                    __extendPlanId: planId,
                    __coveredProductId: product.id,
                    __coveredProductName: product.name,
                  },
                }),
              })
                .then((response) => response.json())
                .then((data) => {
                  const url = new URL(window.location.href);
                  url.searchParams.delete('leadtoken');

                  window.history.replaceState({}, document.title, url.toString());

                  // set timeout for 500 seconds and window reload
                  setTimeout(() => {
                    window.location.reload();
                  }, 500);
                })
                .catch((error) => {
                  console.error('Error adding to cart:', error);
                });
            }
          },
        });
      }
    } catch (error) {
      console.error(`EXTEND: ${error}`);
    }
  }
});
